import { inject, Injectable } from '@angular/core';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { FieldReadHelper } from '../../../../profile-form/helpers/fields/field-read.helper';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { BooleanCell } from '../../components/cells/boolean-cell/boolean-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class BooleanFieldColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.SMALL;
    protected readonly DISABLE_SORT: boolean = false;
    private readonly fieldReadHelper: FieldReadHelper = inject(FieldReadHelper);

    getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return item => {
            const value: boolean | null = this.fieldReadHelper.getBooleanFieldValue(profileField.FieldDefinition, item);

            return new BooleanCell(value);
        };
    }
}
